import {NassauLog} from "./myga-utils";

export const SESSION_MODES = Object.freeze({
  LOCAL : "local",
  SESSION : "session"
});

const setStorage = (key,value,mode) => {
  if (mode === SESSION_MODES.LOCAL) {
    localStorage[key] = value;
  } else {
    sessionStorage[key] = value;
  }
};

const getStorage = (key,mode) => {
  if (mode === SESSION_MODES.LOCAL) {
    return localStorage[key];
  } else {
    return sessionStorage[key];
  }
};

const deleteStorage = (key,mode) => {
  if (mode === SESSION_MODES.LOCAL) {
    delete localStorage[key];
  } else {
    delete sessionStorage[key];
  }
};

const logStorage = (mode) => {
  if (mode === SESSION_MODES.LOCAL) {
    NassauLog(`localStorage: ${JSON.stringify(localStorage,null,2)}`);
  } else {
    NassauLog(`sessionStorage: ${JSON.stringify(sessionStorage,null,2)}`);
  }
};

/**
 * Return true if the object is null
 * @param obj
 * @returns {boolean}
 */
const isNull = (obj) => {
  return obj === null;
};

/**
 * Return true if the object is undefined
 * @param obj
 * @returns {boolean}
 */
const isUndefined = (obj) => {
  return obj === void 0;
};

/**
 * Returns true if the oject is neither null nor undefined
 * @param obj
 * @returns {boolean|boolean}
 */
const isValid = (obj) => {
  return (!isNull(obj) && !isUndefined(obj));
};


const isString = (obj) => {
  return (typeof obj === 'string' || obj instanceof String);
};

export class SessionHelper {
  constructor(mode) {
    this._mode = mode;
  }
  
  log = () => {
    logStorage(this._mode);
  };
  
  /**
   * Set a Sesion value
   * @param key
   * @param value
   * @returns {any}
   */
  setSessionValue = (key, value) => {
    if (isValid(key)) {
      if (isValid(value)) {
        setStorage(key,value,this._mode);
        return value;
      } else {
        let prev = getStorage(key,this._mode);
        deleteStorage(key,this._mode);
        return prev;
      }
    }
    return null;
  };
  
  /**
   * Get a value from storage.
   * If not present then the default value will be used
   * and set in session storage.
   * @param key
   * @param defaultValue
   * @returns {null|*}
   */
  getSessionValue = (key, defaultValue = null) => {
    if (isValid(key)) {
      let value = getStorage(key,this._mode);
      if (isValid(value)) {
        return value;
      } else if (isValid(defaultValue)) {
        this.setSessionValue(key,defaultValue,this._mode);
        return defaultValue;
      }
    }
    return null;
  };
  
  /**
   * Clear the value for the given key
   * @param key
   */
  clearSessionValue = (key) => {
    if (isValid(key)) {
      let value = getStorage(key,this._mode);
      deleteStorage(key,this._mode);
      return value;
    }
    return null;
  }
}

